import React from 'react';
import { BarChart3Icon, TargetIcon, ClockIcon, TrendingUpIcon, MoonIcon, SunIcon } from 'lucide-react';
import type { ViewType } from '../../types';
interface SidebarProps {
  activeView: ViewType;
  onViewChange: (view: ViewType) => void;
  isDark: boolean;
  onToggleDark: () => void;
}
const navItems: {
  view: ViewType;
  label: string;
  icon: React.ReactNode;
}[] = [{
  view: 'dashboard',
  label: 'Dashboard',
  icon: <BarChart3Icon className="w-5 h-5" data-id="element-278" />
}, {
  view: 'goals',
  label: 'Goal Settings',
  icon: <TargetIcon className="w-5 h-5" data-id="element-279" />
}, {
  view: 'history',
  label: 'History',
  icon: <ClockIcon className="w-5 h-5" data-id="element-280" />
}];
export function Sidebar({
  activeView,
  onViewChange,
  isDark,
  onToggleDark
}: SidebarProps) {
  return <nav className="fixed left-0 top-0 bottom-0 w-60 bg-slate-800 text-white flex flex-col z-30" aria-label="Main navigation" data-id="element-281">
      {/* Logo / App Title */}
      <div className="flex items-center gap-3 px-5 py-6 border-b border-slate-700" data-id="element-282">
        <div className="w-9 h-9 rounded-lg bg-blue-500 flex items-center justify-center flex-shrink-0" data-id="element-283">
          <TrendingUpIcon className="w-5 h-5 text-white" data-id="element-284" />
        </div>
        <div data-id="element-285">
          <h1 className="text-base font-bold leading-tight" data-id="element-286">Goal Tracker</h1>
          <p className="text-xs text-slate-400 leading-tight" data-id="element-287">
            Performance Metrics
          </p>
        </div>
      </div>

      {/* Navigation */}
      <div className="flex-1 py-4 px-3 space-y-1" data-id="element-288">
        {navItems.map(item => {
        const isActive = activeView === item.view;
        return <button key={item.view} onClick={() => onViewChange(item.view)} className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? 'bg-blue-600 text-white shadow-sm' : 'text-slate-300 hover:bg-slate-700 hover:text-white'}`} aria-current={isActive ? 'page' : undefined} aria-label={`Navigate to ${item.label}`} data-id="element-289">
              {item.icon}
              {item.label}
            </button>;
      })}
      </div>

      {/* Dark Mode Toggle */}
      <div className="px-3 pb-3" data-id="element-290">
        <button onClick={onToggleDark} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-slate-300 hover:bg-slate-700 hover:text-white transition-colors" aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`} data-id="element-291">
          {isDark ? <>
              <SunIcon className="w-5 h-5" data-id="element-292" />
              Light Mode
            </> : <>
              <MoonIcon className="w-5 h-5" data-id="element-293" />
              Dark Mode
            </>}
        </button>
      </div>

      {/* Footer */}
      <div className="px-5 py-4 border-t border-slate-700" data-id="element-294">
        <p className="text-xs text-slate-500" data-id="element-295">© 2026 Loan Performance</p>
      </div>
    </nav>;
}